import React from 'react';
import { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import Script from 'next/script';

import { PRIVACY_KEY } from '@/shared/components/precision/cookie-notice';

const YM_ID = 96886492;

// eslint-disable-next-line react/display-name
export const YandexMetric = () => {
  const router = useRouter();
  const [consent, setConsent] = React.useState(false);

  React.useEffect(() => {
    const update = () => {
      try {
        setConsent(localStorage.getItem(PRIVACY_KEY) === 'all');
      } catch {
        setConsent(false);
      }
    };
    update();
    window.addEventListener('domstankov:privacy-change', update);
    window.addEventListener('storage', update);
    return () => {
      window.removeEventListener('domstankov:privacy-change', update);
      window.removeEventListener('storage', update);
    };
  }, []);

  React.useEffect(() => {
    if (
      consent &&
      process.env.NODE_ENV === 'production' &&
      ['domstankov.com', 'www.domstankov.com'].includes(location.hostname) &&
      typeof window.ym === 'function'
    ) {
      window.ym(YM_ID, 'hit', window.location.href);
    }
  }, [consent, router.pathname, router.query]);

  if (
    process.env.NODE_ENV !== 'production' ||
    !consent ||
    typeof window === 'undefined' ||
    !['domstankov.com', 'www.domstankov.com'].includes(location.hostname)
  )
    return null;

  return (
    <>
      <Script strategy="afterInteractive" id="yandex-metrika">
        {`
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(${YM_ID}, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true
        });
      `}
      </Script>
    </>
  );
};
